import Button from "@mui/material/Button";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled, { css } from "styled-components";
import { FlexColumn } from "./common.styles";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { fontWeights } from "healthex-common/weights";
import patientIconSVG from "../Media/patient-icon.svg";
import orgIconSVG from "../Media/org-icon.svg";
export const UserLoginTypeSelectButtons = styled(FlexColumn) `
    gap: 12px;
`;
export const UserLoginTypeSelectButton = styled(Button) `
    display: flex;
    padding: 12px 9px 12px 14px;
    gap: 12px;
    align-items: center;
    align-self: stretch;
    min-height: 72px;
    border-radius: 12px;
    border: 1px solid ${colors.blue_30};
    background-color: ${colors.white_main};

    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const UserLoginTypeSelectButtonText = styled.div `
    flex-grow: 1;
`;
export const UserLoginTypeSelectButtonArrow = styled(ChevronRight) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
    opacity: 0.7;
`;
const BaseIcon = css `
    width: 36px;
    height: 36px;
`;
export const PatientIcon = styled.img.attrs({ src: patientIconSVG }) `
    ${BaseIcon}
`;
export const OrgIcon = styled.img.attrs({ src: orgIconSVG }) `
    ${BaseIcon}
`;
